import { render, staticRenderFns } from "./nshop-order-cancel-mark-dialog.vue?vue&type=template&id=3320aff0&"
import script from "./nshop-order-cancel-mark-dialog.vue?vue&type=script&lang=js&"
export * from "./nshop-order-cancel-mark-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports